// extracted by mini-css-extract-plugin
module.exports = {"formContent":"UserInformation_formContent_bDLNS"};